/* 遵循ant-design-pro定义接口规范 */
/* https://github.com/ant-design/ant-design-pro */

import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { categoriesDetailArray, categoriesMenusState, spusDetailState } from "./interface/categoriesInterface"

/** 获取产品种类接口 */
export async function categoriesTypeMenu(): Promise<categoriesMenusState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesMenusState>('/v1/api/pms/categories')
}

/** 根据产品种类,获取种类下的全部商品 */
export async function categoriesDetail(id: string): Promise<categoriesDetailArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>("/v1/api/pms/categories/" + id + "/spus")
}

export async function spusDetail(id: string): Promise<spusDetailState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/pms/spu/" + id + "/skus")
}

export async function spusComment(id: number, data: any): Promise<spusDetailState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/pms/spu/" + id + "/comment", data)
}
export async function spusCount(id: number): Promise<spusDetailState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/pms/spu/" + id + "/comment/count")
}
/** 根据产品种类,获取种类下的全部商品 */
export async function getSpuDetail(id: number, spu_id: number): Promise<categoriesDetailArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>(`/v1/api/pms/categories/${id}/spus/${spu_id}`)
}
